import React from 'react';
import './Shimmer.css';

interface ShimmerProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Shimmer: React.FC<ShimmerProps> = ({ 
  width = '100%', 
  height = '20px', 
  borderRadius = '4px',
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`shimmer ${className}`}
      style={{ 
        width, 
        height, 
        borderRadius,
        ...style
      }}
    />
  );
};

export default Shimmer;
